/**
 * @param list An array.
 * @param keyGetter Function that returns the key you want to group by.
 *
 * @returns Group of the array grouped by the grouping function.
 */

export function groupBy(list = [], keyGetter) {
  try {
    const map = new Map();
    const safeList = Array.isArray(list) ? list : [];

    safeList?.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });

    return Object.fromEntries(map);
  } catch (error) {
    console.error(error);
    return {};
  }
}
